"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomMessage_1 = require("@react-form-fields/core/components/CustomMessage");
exports.default = CustomMessage_1.default;
//# sourceMappingURL=CustomMessage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/CustomMessage.js
// module id = 475
// module chunks = 58